export default __webpack_public_path__ + "static/media/Ilus-Agiliza.608cf87a.svg";